/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2e",".pagination-pages .pagination-page{padding-top:12px;text-align:center}.pagination-pages a{color:#555}.pagination-pages .page,.pagination-pages .page-cur,.pagination-pages .page-next,.pagination-pages .page-prev{display:inline-block;width:34px;height:34px;line-height:34px;font-size:14px;text-align:center}.pagination-pages .page-cur{color:#fff;width:36px;height:36px;background:#f85300;line-height:36px}.pagination-pages .page{border:1px solid #ddd;background:#fff}.pagination-pages .page-split{margin:0 8px;font-size:14px}.pagination-pages .page-prev{margin-right:5px}.pagination-pages .page-next{margin-left:5px}.pagination-pages .page-next,.pagination-pages .page-prev{border:1px solid #ddd;background:#fff;width:45px;font-family:arial,verdana,sans-serif;line-height:35px;color:#333}.pagination-pages .pageJump{display:inline-block;width:45px;height:18px;line-height:18px;background:#f8f8f8;color:#999;text-align:center;vertical-align:middle;border:1px solid #ddd}.pagination-pages .pageJump input{width:45px;height:18px;border:0;text-align:center}.pagination-pages .text{color:#666;margin-left:15px;margin-right:5px}.pagination-pages .text2{margin-left:5px}.pagination-pages .totalPage{margin-left:30px;color:#666}.pagination-pages .pageConfirm{display:inline-block;margin-left:17px;line-height:20px;width:45px;height:18px;vertical-align:middle;background:#fff;color:#333;border:1px solid #ddd}");

module.exports = Magix.View.extend({
    tmpl: {"html":"<div id=\"J_waterfallPagination\" class=\"pagination\"></div>","subs":[]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            Node: null
        });
    },
    initPagination: function initPagination() {
        var S = this.opt.S,
            Node = this.opt.Node;

        function Pagination(config) {
            this.configs = S.mix({
                index: 1,
                step: 3,
                // totalPages: 10,
                itemsPerPage: 50,
                totalItems: 300,
                showTotalPages: true,
                showLastPage: true,
                goToUrl: window.location.href,
                pageName: 'page',
                params: {},
                paramsArr: false
            }, config);
            // setup urlInfo
            this.urlInfo = this.parseUrl(this.configs.goToUrl);
            if (this.configs.params) {
                S.each(this.configs.params, function (k, v) {
                    this.urlInfo.params[k] = v;
                });
            }

            // set page information
            this.index = parseInt(this.urlInfo.params[this.configs.pageName], 10) || this.configs.index;
            this.totalPages = this.configs.totalPages || Math.ceil(this.configs.totalItems / this.configs.itemsPerPage);
        }

        S.mix(Pagination.prototype, {
            parseUrl: function parseUrl(url) {
                var a = document.createElement('a');
                a.href = url;
                return {
                    source: url,
                    protocol: a.protocol.replace(':', ''),
                    host: a.hostname,
                    port: a.port,
                    query: a.search,
                    params: function () {
                        return S.unparam(a.search.replace(/^\?/, ''));
                    }(),
                    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
                    hash: a.hash.replace('#', ''),
                    path: a.pathname.replace(/^([^\/])/, '/$1'),
                    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
                    segments: a.pathname.replace(/^\//, '').split('/')
                };
            },
            doUrl: function doUrl() {
                var self = this;
                var urlInfo = self.urlInfo;
                var index = self.index;
                var pageName = self.configs.pageName;
                var returnUrl;
                urlInfo.params[pageName] = index;
                urlInfo.params.keyword = decodeURI(window._SEARCHKEYWORDS);
                if (!urlInfo.params._input_charset) {
                    urlInfo.params._input_charset = 'utf-8';
                }
                returnUrl = urlInfo.protocol + '://' + urlInfo.host;
                if (urlInfo.port != 0 && urlInfo.port != 80) {
                    returnUrl += ':' + urlInfo.port;
                }
                returnUrl += urlInfo.path + '?';

                returnUrl += S.param(urlInfo.params, '&', '=', self.configs.paramsArr);
                if (urlInfo.hash != '') {
                    returnUrl += '#' + encodeURIComponent(urlInfo.hash);
                }
                return returnUrl;
            },
            render: function render(page) {
                var index = page || this.index;
                var step = this.configs.step;
                var seed = 1;
                var max = this.totalPages;
                var pageName = this.configs.pageName;
                var formatUrl = this.doUrl();
                var arrHTML = [];

                formatUrl = formatUrl.replace(pageName + '=' + index, pageName + '={$p}');
                arrHTML.push('<div class="pagination-pages"><div class="pagination-page">');
                if (index > 1) {
                    arrHTML.push('<a href="' + formatUrl.replace('{$p}', seed * (this.index - 1)) + '" class="page-prev iconfont">上一页</a>');
                }
                var start = Math.max(1, index - parseInt(step / 2, 10));
                var end = Math.min(max, start + step - 1);
                start = Math.max(1, end - step + 1);

                if (start >= 3) {
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * 1) + '">1</a>');
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * 2) + '">2</a>');
                    if (start > 3) {
                        arrHTML.push('<span class="page-split">...</span>');
                    }
                } else if (start == 2) {
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * 1) + '">1</a>');
                }

                for (var i = start; i <= end; i++) {
                    if (i === index) {
                        arrHTML.push('<span class="page-cur">' + i + '</span>');
                    } else {
                        arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * i) + '">' + i + '</a>');
                    }
                }
                if (end + 2 <= max) {
                    arrHTML.push('<span class="page-split">...</span>');
                    if (this.configs.showLastPage) {
                        arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * max) + '">' + max + '</a>');
                    }
                } else if (end < max) {
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * max - 1) + '">' + max + '</a>');
                }

                if (index != max) {
                    arrHTML.push('<a href="' + formatUrl.replace('{$p}', seed * index) + '" class="page-next iconfont">下一页</a>');
                }
                arrHTML.push('<span class="totalPage">共' + max + '页</span>');
                arrHTML.push('<span class="text">去第</span><a href="javascript:;" class="pageJump"><input  id="Jumper" value="' + index + '" name="page" type="text"/></a><span class="text2">页</span><a  href="' + formatUrl.replace('{$p}', seed * index) + '" class="pageConfirm">确定</a>');
                // if (this.configs.showTotalPages) {
                //     arrHTML.push('<div class="pagination-count"><span>共</span><span class="b">' + max + '</span><span>页</span></div>');
                // }
                arrHTML.push('</div>');

                //render Jump
                //if (self.get('jump')) {
                //  arrHTML.push('<div class="pagination-form"><span>向第</span><input class="page-num" value="' + Math.min(max, index + 1) + '" name="page" type="text"><span>页</span><a class="btn-jump btn btn-size25">跳转</a></div>');
                // }

                arrHTML.push('</div>');

                S.one(this.configs.container).html(arrHTML.join(''));
            }
        });
        return Pagination;
    },
    renderPagination: function renderPagination(Pagination) {
        var S = this.opt.S;
        var pagination = new Pagination({
            container: '#J_waterfallPagination',
            totalPages: 100,
            pageName: 'page',
            showTotalPages: true,
            showLastPage: true
        });
        pagination.render();
        S.one('#Jumper').on('blur', function (e) {
            var page = Math.floor(Node(e.currentTarget).val());
            if (page < 0 || page > 100) {
                return;
            }
            var confirms = S.one('.pageConfirm'),
                url = confirms.attr('href');
            var newUrl = url.replace(/page=\d+/g, function (a, b, c) {
                return 'page=' + page;
            });
            confirms.attr('href', newUrl);
        });
    },
    render: function render() {
        var self = this;

        KISSY.use("node", function (S, Node) {
            self.opt.Node = Node;
            self.updater.set({}).digest();
            self.renderPagination(self.initPagination());
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/pagination/index.js
// module id = 6
// module chunks = 1 2